import React from "react";
import {BrowserRouter, Outlet, Route, Routes} from "react-router-dom";
import Home from "./components/home/Home";
import Login from "./components/login/Login"
import Balance from "./components/balance/Balance"
import Navigation from "./components/_core/Navigation";
import Footer from "./components/_core/Footer";
import ContactList from "./components/contact/ContactList";
import ContactDetail from "./components/contact/ContactDetail";
import CreditNoteList from "./components/credit-note/CreditNoteList";
import CreditNoteDetail from "./components/credit-note/CreditNoteDetail";
import ExportSteuerberater from "./components/export/ExportSteuerberater";
import InvoiceList from "./components/invoice/InvoiceList";
import InvoiceDetail from "./components/invoice/InvoiceDetail";
import ItemList from "./components/item/ItemList";
import Item from "./components/item/Item";
import OperatingCost from "./components/operating-cost/OperatingCost";
import OperatingCostNew from "./components/operating-cost/OperatingCostNew";
import ZohoGrabberContact from "./components/zoho-grabber/ZohoGrabberContact";
import ZohoGrabberItem from "./components/zoho-grabber/ZohoGrabberItem";
import ZohoGrabberInvoice from "./components/zoho-grabber/ZohoGrabberInvoice";
import ZohoGrabberCreditNote from "./components/zoho-grabber/ZohoGrabberCreditNote";
import {Container} from "semantic-ui-react";

const NotFound = () => (
    <h1>code404 - Page not found</h1>
)

const Layout = () => {
    return <div>
        <Navigation/>
        <Container style={{marginTop: '7em'}}>
            <Outlet/>
        </Container>
        <Footer/>
    </div>
}

export default function AppRoutes(props) {
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path='balance'>
                        <Route path=":year" element={<Balance/>}/>
                    </Route>
                    <Route path='contacts'>
                        <Route index element={<ContactList/>}/>
                        <Route path=":contactId" element={<ContactDetail/>}/>
                    </Route>
                    <Route path='credit-notes'>
                        <Route index element={<CreditNoteList/>}/>
                        <Route path=":creditNoteId" element={<CreditNoteDetail/>}/>
                    </Route>

                    <Route path='export'>
                        <Route path="steuerberater" element={<ExportSteuerberater/>}/>
                    </Route>
                    <Route/>
                    <Route path='invoices'>
                        <Route index element={<InvoiceList/>}/>
                        <Route path=":invoiceId" element={<InvoiceDetail/>}/>
                    </Route>


                    <Route path='items'>
                        <Route index element={<ItemList/>}/>
                        <Route path=":itemId" element={<Item/>}/>
                    </Route>


                    <Route path='login' element={<Login/>}/>
                    <Route path='operating-costs'>
                        <Route index element={<OperatingCost/>}/>
                        <Route path="new" element={<OperatingCostNew/>}/>
                    </Route>


                    <Route path='zoho-grabber'>
                        <Route path="contact" element={<ZohoGrabberContact/>}/>
                        <Route path="item" element={<ZohoGrabberItem/>}/>
                        <Route path="invoice" element={<ZohoGrabberInvoice/>}/>
                        <Route path="credit-note" element={<ZohoGrabberCreditNote/>}/>
                    </Route>


                    <Route path='*' element={<NotFound/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

